import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import './fulfillment-options.scss';
type FulfillmentOptionsProps = Readonly<{
  children: ReactNode;
  'data-testid'?: string;
}>;
export const FulfillmentOptions = t0 => {
  const $ = _c(3);
  const {
    children,
    "data-testid": testId
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== testId) {
    t1 = <fieldset className="delivery-options" data-testid={testId}>{children}</fieldset>;
    $[0] = children;
    $[1] = testId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};